var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup232(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.566,
    height: 26.002,
    viewBox: "0 0 24.566 26.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "property-svgrepo-com",
    transform: "translate(0 6.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M23.59,17.818H21.725V1.243h.622a.622.622,0,1,0,0-1.243H7.43a.622.622,0,0,0,0,1.243h.622V17.818H6.187a.622.622,0,0,0,0,1.243h17.4a.622.622,0,0,0,0-1.243Zm-9.323-1.865a.622.622,0,0,1-.622.622H11.159a.622.622,0,0,1-.622-.622V13.467a.622.622,0,0,1,.622-.622h2.486a.622.622,0,0,1,.622.622Zm0-4.972a.622.622,0,0,1-.622.622H11.159a.622.622,0,0,1-.622-.622V8.495a.622.622,0,0,1,.622-.622h2.486a.622.622,0,0,1,.622.622Zm0-4.972a.622.622,0,0,1-.622.622H11.159a.622.622,0,0,1-.622-.622V3.522a.622.622,0,0,1,.622-.622h2.486a.622.622,0,0,1,.622.622Zm4.972,9.945a.622.622,0,0,1-.622.622H16.131a.622.622,0,0,1-.622-.622V13.467a.622.622,0,0,1,.622-.622h2.486a.622.622,0,0,1,.622.622Zm0-4.972a.622.622,0,0,1-.622.622H16.131a.622.622,0,0,1-.622-.622V8.495a.622.622,0,0,1,.622-.622h2.486a.622.622,0,0,1,.622.622Zm0-4.972a.622.622,0,0,1-.622.622H16.131a.622.622,0,0,1-.622-.622V3.522a.622.622,0,0,1,.622-.622h2.486a.622.622,0,0,1,.622.622Z",
    transform: "translate(-5.565)",
    fill: "#956800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(12.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(0)",
    fill: "#956800",
    stroke: "#f5d792",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.036,
    cy: 6.036,
    r: 6.036,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.036,
    cy: 6.036,
    r: 5.536,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Complete",
    transform: "translate(2.924 2.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_14",
    "data-name": "Line 14",
    d: "M-.689,5.225A.357.357,0,0,1-1,4.836V-.611A.357.357,0,0,1-.689-1a.357.357,0,0,1,.311.389V4.836A.357.357,0,0,1-.689,5.225Z",
    transform: "translate(3.801 1)",
    fill: "#f5d792"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_15",
    "data-name": "Line 15",
    d: "M4.836-.378H-.611A.357.357,0,0,1-1-.689.357.357,0,0,1-.611-1H4.836a.357.357,0,0,1,.389.311A.357.357,0,0,1,4.836-.378Z",
    transform: "translate(1 3.801)",
    fill: "#f5d792"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup232);
export default __webpack_public_path__ + "static/media/Group 232.7b2b4a4ba666e2d6379acc9d8bc1ed14.svg";
export { ForwardRef as ReactComponent };